import React from "react";
import { cn } from "@/utils/cn";

interface Props {
	onMouseDown: (e: React.MouseEvent) => void;
	onDoubleClick: (e: React.MouseEvent) => void;
	active: boolean;
}

/**
 * The grab bar on the right edge of a resizable header cell. Sits over the column
 * boundary; drag to resize, double-click to reset to the default width. The
 * parent `<th>` must be `relative` for the absolute positioning to anchor.
 */
const ColumnResizeHandle: React.FC<Props> = ({ onMouseDown, onDoubleClick, active }) => (
	<span
		onMouseDown={onMouseDown}
		onDoubleClick={onDoubleClick}
		// Swallow the click so it doesn't reach the header's sort handler.
		onClick={(e) => e.stopPropagation()}
		className={cn(
			"absolute top-0 right-0 z-10 flex h-full w-2 translate-x-1/2 cursor-col-resize items-center justify-center",
			"before:h-1/2 before:w-px before:bg-border hover:before:w-0.5 hover:before:bg-action",
			active && "before:w-0.5 before:bg-action"
		)}
	/>
);

export default ColumnResizeHandle;
